import { Component } from '@angular/core';

@Component({
  selector: 'app-daily-movement',
  standalone: false,
  
  templateUrl: './daily-movement.component.html',
  styles: ``
})
export class DailyMovementComponent {

}
